import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import * as settingsAction from "store/entities/settingsInfo/action";
import * as accountActions from "store/auth/account/action";
import * as complianceAction from "store/entities/compliance/action";

import { ButtonLoader, Input } from "components/__new/common/form";
import FormDrawer from '../form-drawer';
import validate from "utils/validate";
import { REGEX_VALUES } from 'utils/regexValues';





const CompanyInfoModal = (props) => {
    const {isOpen, setIsOpen, company} = props;
    const dispatch = useDispatch();

const { companyInfo, companyInfoSettingsLoading, companyInfoSettings } = useSelector((s) => s.entities.settingsInfo);

const [isUpdated,  setIsUpdated] = useState(false)

const [form, setForm] = useState({
});


useEffect(() => {
    
    const newForm = {
    companyName: company?.companyName ?? '',
    estimatedEmployees: company?.estimatedEmployees ?? '',
    industry: company?.industry ?? '',
    registrationNumber: company?.registrationNumber ?? '',
    taxIdentificationNumber: company?.taxIdentificationNumber ?? '',
    address: company?.address ?? '',
    country: company?.country ?? '',
    website: company?.socials?.website ?? '',
    invoiceEmail: company?.invoiceEmail ?? '',
    estimatedSalary: company?.estimatedSalary ?? '',
    }
    
    setForm(newForm)
}, [company]);

useEffect(() => {
    dispatch(accountActions.getEmployerInfo());
}, []);


const handleCompanyInfoChange = (e) => {
    const { name, value } = e.target;
    if ((name === "companyName" ) && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 60)) {
        return;
      } else if ((name === "estimatedEmployees" ) && (REGEX_VALUES.NUMBERS_ONLY.test(value) || value.length > 6)) {
        return;
      } else if ((name === "industry" ) && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
        return;
      } else if ((name === "registrationNumber" ) && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY_WITH_SPACE.test(value) || value.length > 30)) {
        return;
      } else if ((name === "taxIdentificationNumber" ) && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY_WITH_SPACE.test(value) || value.length > 30)) {
        return;
      } else if ((name === "address" ) && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 60)) {
        return;
      } else if ((name === "country" ) && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
        return;
      } else if ((name === "website" ) && (value.length > 50)) {
        return;
      } else if ((name === "invoiceEmail" ) && (!REGEX_VALUES.EMAIL.test(value) || value.length > 40)) {
        return;
      } else if ((name === "estimatedSalary" ) && (!REGEX_VALUES.NUMBERS_ONLY.test(value) || value.length > 15)) {
        return;
      }  
      
    setForm(prevForm => ({
        ...prevForm,
        [name]: value
    }));
};

const submitForm = async (e) => {
    e.preventDefault();
    
    const errors = validate({estimatedEmployees: form.estimatedEmployees});
    if (errors){
        for (var x in errors) {
            toast.error(errors[x]);
        };
        return;
    }
    else{
        const params = {
            estimatedEmployees: parseInt(form.estimatedEmployees),
            // website: form.website,
        }
        
        if(form.website.length > 0){
        const socials = {
            website: form.website,
        }
        dispatch(complianceAction.addSocials(socials));
    }
        dispatch(settingsAction.updateCompanyInfoSettings(params));
        setIsUpdated(true);
        
    }
    // setIsOpen(false);

}
    
/* 
 useEffect(() => {
     if (companyInfoSettings){
         dispatch(accountActions.resetUpdateCompanyInfo());
     } 
     }
    //   eslint-disable-next-line
 , [companyInfoSettings])
  */
    

 useEffect(() => {
     if (companyInfoSettings?.id && isUpdated){
         dispatch(accountActions.getEmployerInfo());
         dispatch(settingsAction.resetUpdateCompanyInfo());
        setIsOpen(false);
        setIsUpdated(false);
        toast.success("Company info updated successfully");
     } 
     }
    //   eslint-disable-next-line
 , [companyInfoSettings])
 
 

    return (
    
    <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={submitForm} className="p-6">
                <FormDrawer.Title
                    title="Edit Company Info"
                    description="Manage your company's information"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <hr />
                
                <div className='py-4 text-ep-gray-700 font-medium'>
                    <Input
                        type="text"
                        label="Company Name"
                        placeholder=""
                        name="companyName"
                        value={form.companyName}
                        onChange={handleCompanyInfoChange}
                        readonly
                    />
                    <Input
                        type="text"
                        label="Number of Employees"
                        placeholder=""
                        name="estimatedEmployees"
                        value={form.estimatedEmployees}
                        onChange={handleCompanyInfoChange}
                    />
                    <Input
                        type="text"
                        label="Industry"
                        placeholder=""
                        name="industry"
                        value={form.industry}
                        onChange={handleCompanyInfoChange}
                        readonly
                    />
                    <Input
                        type="text"
                        label="Business Registration Number"
                        placeholder=""
                        name="registrationNumber"
                        value={form.registrationNumber}
                        onChange={handleCompanyInfoChange}
                        readonly
                    />
                    <Input
                        type="text"
                        label="Tax Identification Number"
                        placeholder=""
                        name="taxIdentificationNumber"
                        value={form.taxIdentificationNumber}
                        onChange={handleCompanyInfoChange}
                        readonly
                    />
                    <Input
                        type="text"
                        label="Address"
                        placeholder=""
                        name="address"
                        value={form.address}
                        onChange={handleCompanyInfoChange}
                        readonly
                    />
                    <Input
                        type="text"
                        label="Country"
                        placeholder=""
                        name="country"
                        onChange={handleCompanyInfoChange}
                        value={form.country}
                        readonly
                    />
                    {/* <SelectInput
                        type="text"
                        label="Country"
                        placeholder=""
                        name="country"
                        onChange={handleCompanyInfoChange}
                        // value={form.country}
                        disabled
                    >
                        <option value={form.country}>{form.country}</option>
                    </SelectInput> */}
                    <Input
                        type="text"
                        label="Website"
                        placeholder=""
                        name="website"
                        value={form.website}
                        onChange={handleCompanyInfoChange}
                    />
                </div>
                <div className="p-1 mt-4 flex justify-end space-x-3">
                    <button onClick={() => setIsOpen(false)} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                        Cancel
                    </button>
                    <ButtonLoader loading={companyInfoSettingsLoading} type="submit" disable={companyInfoSettingsLoading} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Save Changes
                    </ButtonLoader>
                </div>
            </form>
        </FormDrawer>
  )
}

export default CompanyInfoModal